<script>
	import { goto } from '$app/navigation';
	import { PAGES } from '$lib/utils/constants';
  import ComponentLogInOutButton from '$lib/components/ComponentLogInOutButton.svelte';

	export let content = {
		loginBtnTxt: '',
		logoutBtnTxt: '',
		signUpBtnTxt: '',
    logoSubHeader: ''
	};
</script>

<div
	class="flex h-[6.2rem] w-full flex-col items-center bg-[url('/assets-mkt/routes/home/yellow_banner_wave_v1_1x.svg')] bg-cover bg-center bg-no-repeat text-white sm:h-[11.6rem] sm:bg-[url('/assets-mkt/routes/home/yellow_banner_wave_v1_2x.svg')] md:h-[14.4rem] md:bg-[url('/assets-mkt/routes/home/yellow_banner_wave_v1_3x.svg')] lg:h-[19.3rem] lg:bg-[url('/assets-mkt/routes/home/yellow_banner_wave_v1_4x.svg')] xl:h-[29rem] xl:bg-[url('/assets-mkt/routes/home/yellow_banner_wave_v1_5x.svg')]"
>
	<header
		class="z-[1] mt-[0.7rem] flex w-full max-w-[30rem] flex-col sm:mt-[2.5rem] sm:max-w-[62rem] md:max-w-[118rem] lg:max-w-[142rem] xl:mt-[5rem] xl:max-w-[142rem]"
	>
		<nav
			class="flex h-[2.2rem] items-center justify-end gap-[0.8rem] self-end sm:h-[3rem] sm:gap-[1.3rem] md:h-[4.3rem] md:gap-[2.1rem]"
		>
			<ComponentLogInOutButton content={{
        logoutBtnTxt: content.logoutBtnTxt,
        loginBtnTxt: content.loginBtnTxt,
        dataTrackId: 'home-login'
      }}/>
			<button
				id="home-signup"
				class="btn-secondary-red"
				on:click|preventDefault={() => goto(PAGES.INTERNAL.PROSPECT_REGISTER)}
			>
				{content.signUpBtnTxt}
			</button>
		</nav>

		<img
			class="mt-[.8rem] w-[4.76rem] self-start sm:w-[7.8rem] md:mt-[5rem] md:w-[11rem] xl:mt-[7rem]"
			width="130"
			height="50"
			alt="ABCmouse is certified by the kidSafe Seal Program."
			src="//www.kidsafeseal.com/sealimage/1643675032741265067/abcmouse_medium_darktm.png"
		/>

		<img
			class="mt-[0rem] mb-[.5rem] w-[9.2rem] self-center sm:w-[19.2rem] md:mt-[-3rem] md:w-[29.7rem]"
			width="393"
			height="63"
			src="/assets-mkt/routes/home/logo_large_v1.png"
			alt="ABCmouse logo"
		/>

    <p class="text-center text-[1.2rem] sm:text-[2rem] md:text-[2.6rem] bg-gradient-to-r from-[#8A1DBB] to-[#2B57CF] bg-clip-text text-transparent font-poppins font-extrabold">{content.logoSubHeader}</p>
	</header>
</div>
